//Custom JS by Howl Media

(function($) {
  
  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  var shrinkHeader = 50;
  $(window).scroll(function() {
    var scroll = getCurrentScroll();
    if (scroll >= shrinkHeader) {
      $('header').addClass('scrolled');
    } else {
      $('header').removeClass('scrolled');
    }
  });
  
  
  
  $('#benefits').click(function(){
  	$('.tabbed-container').fadeOut(200, function () {
      	$('#benefits-container').delay( 200 ).fadeIn(200); 
    });
    $(this).removeClass('unactive');
    $('#use').addClass('unactive');
  });
                      
   $('#use').click(function(){
  	$('.tabbed-container').fadeOut(200, function () {
      	$('#use-container').delay( 200 ).fadeIn(200); 
    });
    $(this).removeClass('unactive');
    $('#benefits').addClass('unactive');
  });
  
  
  
  $(document).ready(function(){
    $('#locationModal').click(function(){
      $('.country-modal').addClass('active');
    });
    
    $('.country-modal .icon-text').click(function(){
      $('.country-modal').removeClass('active');
    });
 
    $('.mfp-bg').on('click', function() {
     $('.country-modal').removeClass('active');
    });

  });
  
  //call sidebar order change  
 // responsive_change_box_order_start();
  
  //on resize
   window.addEventListener('resize', responsive_change_box_order );

  
  //change sidebar order on resize
  function responsive_change_box_order() {
     if (window.matchMedia("(max-width: 800px)").matches) {
         jQuery(".aside-container").remove().insertAfter(jQuery(".collection-container"));
     }else{
      	jQuery(".aside-container").remove().insertBefore(jQuery(".collection-container"));
     }
    
  };
  function responsive_change_box_order_start() {
     if (window.matchMedia("(max-width: 800px)").matches) {
         jQuery(".aside-container").remove().insertAfter(jQuery(".collection-container"));
     }else{
      	//jQuery(".aside-container").remove().insertAfter(jQuery(".collection-container"));
     }
    
  };
  
  //remove breaklines
  $(document).ready(function(){
    if ($(window).width() < 1100) {
      $(".side-block .testimonials br").remove();
    };
  });
})(jQuery);